import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { validateUuid } from '@/utils/validate-uuid';
import { Resolution886ReportService } from '@/infra/services/resolution-886-report';

export interface GetResolution886RiskLevelParams {
	organization_id: string;
	company_id: string;
	sector_id?: string;
	line_id?: string;
	workstation_id: string;
	start_date?: string;
	end_date?: string;
}

const Service = Resolution886ReportService.getInstance();

export const useGetResolution886RiskLevel = (params: GetResolution886RiskLevelParams) => {
	const isEnabled = validateUuid([params.organization_id, params.company_id, params.workstation_id]);
	return useQuery({
		queryKey: [QUERY_KEYS.GET_DASHBOARD_RISK_LEVEL, params],
		queryFn: async () => Service.getDashboardRiskLevel(params),
		enabled: isEnabled
	});
};
